import { StorageKey } from "../types";


export default class AppStorage {
  static getItem<T>(key: StorageKey): T | null;
  static getItem<T, D>(key: StorageKey, defaultValue: D): T | D;
  static getItem<T, D = null>(key: StorageKey, defaultValue: D = null as D): T | D {
    if (typeof window !== 'undefined') {
      const data = localStorage.getItem(key);
      if (data) {
        try {
          return JSON.parse(data) as T;
        } catch (e) {
        console.log(e)
          return defaultValue;
        }
      }
    }
    return defaultValue;
  }

  static saveItem<T>(key: StorageKey, value: T): void {
    try {
      const data = JSON.stringify(value);
      localStorage.setItem(key, data);
    } catch (e) {
      console.error(`Error stringifying value for key "${key}":`, e);
    }
  }

  static deleteItem(key: StorageKey): void {
    localStorage.removeItem(key);
  }

  static clear(): void {
    localStorage.clear();
  }

  static key(index: number): string | null {
    return typeof window !== 'undefined' ? localStorage.key(index) : null;
  }

  static get itemCount(): number {
    return typeof window !== 'undefined' ? localStorage.length : 0;
  }
}